var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3659 6.61445L14.3519 2.99575C14.3503 2.5906 14.0214 2.26165 13.6162 2.26008L9.9975 2.2461C9.59034 2.24453 9.26079 2.57408 9.26236 2.98124C9.26393 3.38639 9.59289 3.71535 9.99804 3.71692L11.8457 3.72405L8.48114 7.08859C8.45683 7.10745 8.43352 7.12798 8.41138 7.15012L3.22015 12.3413L3.21301 10.4937C3.21144 10.0886 2.88249 9.75959 2.47734 9.75803C2.07017 9.75645 1.74062 10.086 1.74219 10.4932L1.75617 14.1119C1.75774 14.517 2.0867 14.846 2.49185 14.8475L6.11055 14.8615C6.51771 14.8631 6.84727 14.5335 6.84569 14.1264C6.84413 13.7212 6.51517 13.3923 6.11002 13.3907L4.26237 13.3836L7.62691 10.019C7.65123 10.0002 7.67454 9.97965 7.69668 9.95751L12.8879 4.76628L12.895 6.61392C12.8966 7.01907 13.2256 7.34803 13.6307 7.3496C14.0379 7.35117 14.3674 7.02162 14.3659 6.61445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.c58065cc.svg";
export { ForwardRef as ReactComponent };